import { styled as _styled } from '@mui/material/styles';
import { ImagesSection } from './components/imagesSection';
import { QuestionCategory } from './components/questionCategory';
import { url } from '../../../utils/url';
import { useNavigate } from 'react-router-dom';
import { AdSmallText, AdSmallTextBar, Container, Description, First, HedSubtitle, KContactBox, MainTitle, PageContainer, Second, StyledLink, Zero } from './styles';


const subtitle1 = 'Pytania od Klientów:';
const subtitle2 = 'Pytania od Podwykonawców:';
//const subtitle3 = 'Kategoria pytań numer trzy';

export type FaqArrayProps = {
    key: number;
    question: string;
    answer: string;
    content: string;
    header: string;

};
const faqTable1: FaqArrayProps[] = [
    {
        key: 1,
        question: 'Jak mogę zarejestrować się i korzystać z systemu do zarządzania przestrzenią magazynową?<br /> &lt;&lt;patrz pytania od podwykonawców pkt. 1&gt;&gt;',
        answer: 'Odpowiedź na pytanie nr 1',
        content: '1bh-content',
        header: '1bh-header',
    },
    {
        key: 2,
        question: '<b>Jakie rodzaje usług magazynowych oferujecie i jakie są ich koszty?</b>',
        answer: 'Oferujemy szeroki zakres usług magazynowych, a nasza baza magazynów jest systematycznie rozszerzana, co pozwala nam elastycznie dostosowywać ofertę do różnorodnych potrzeb naszych klientów. Koszty naszych usług są generowane automatycznie i zależą od wielu czynników, takich jak rodzaj towaru, jego ilość, dodatkowe usługi, wymogi temperaturowe, klasyfikacja ADR oraz lokalizacja składowania. Dzięki temu każda oferta jest indywidualnie dostosowywana do konkretnej sytuacji i potrzeb klienta. ',
        content: '2bh-content',
        header: '2bh-header',

    },
    {
        key: 3,
        question: 'Czy mogę śledzić dostępność przestrzeni magazynowej w czasie rzeczywistym?',
        answer: 'Odpowiedź na pytanie nr 3',
        content: '3bh-content',
        header: '3bh-header',
    }, 
    {
        key: 4,
        question: 'Czy system umożliwia mi dostosowanie przestrzeni magazynowej do moich indywidualnych potrzeb?',
        answer: 'Odpowiedź na pytanie nr 4',
        content: '4bh-content',
        header: '4bh-header',
    },
    {
        key: 5,
        question: 'Jakie są korzyści płynące z korzystania z waszego systemu w porównaniu z tradycyjnymi usługami magazynowymi?',
        answer: 'Odpowiedź na pytanie nr 5',
        content: '4bh-content',
        header: '4bh-header',
    },
    {
        key: 6,
        question: 'Czy system zapewnia kontrolę temperatury i zabezpieczenia dla specjalistycznych towarów, takich jak produkty medyczne czy artykuły spożywcze?',
        answer: 'Odpowiedź na pytanie nr 6',
        content: '4bh-content',
        header: '4bh-header',
    },
    {
        key: 7,
        question: 'Czy istnieje możliwość monitorowania stanu mojego zapasu i zamówień za pośrednictwem systemu?',
        answer: 'Odpowiedź na pytanie nr 7',
        content: '4bh-content',
        header: '4bh-header',
    },
    {
        key: 8,
        question: 'Czy oferujecie usługi transportu i dystrybucji towarów z magazynów do klientów?',
        answer: 'Odpowiedź na pytanie nr 8',
        content: '4bh-content',
        header: '4bh-header',
    },
    {
        key: 9,
        question: 'Czy system oferuje śledzenie historii moich zamówień i przesyłek?',
        answer: 'Odpowiedź na pytanie nr 9',
        content: '4bh-content',
        header: '4bh-header',
    },
    {
        key: 10,
        question: '<b>Jak długo trwa generowanie ofert?</b>',
        answer: 'Nasz system jest zaprojektowany do generowania ofert natychmiast po uzupełnieniu wymaganych informacji. W przypadku niestandardowych zleceń, takich jak obsługa e-commerce, oferta zostanie przesłana do ciebie w ciągu 24 godziny od momentu złożenia zapytania. Ten proces zapewnia dokładność i kompleksowość oferty w przypadku nietypowych zleceń.',
        content: '4bh-content',
        header: '4bh-header',
    }
]
const faqTable2: FaqArrayProps[] = [
    {
        key: 1,
        question: 'Jak mogę zostać podwykonawcą w waszym systemie i oferować usługi magazynowe?',
        answer: 'Aby zarejestrować się w naszym systemie , wystarczy przejść przez kilka prostych kroków. Po pierwsze, kliknij przycisk "Rejestracja" dostępny na naszej platformie. Następnie wypełnij formularz rejestracyjny, podając wszystkie wymagane dane. Po złożeniu rejestracji, operator systemu dokładnie zweryfikuje poprawność podanych informacji. Jeśli wszystkie dane są prawidłowe, zostaniesz zarejestrowany w naszym systemie. W przypadku brakujących lub niekompletnych informacji, skontaktujemy się z Tobą, aby uzyskać brakujące dane lub uzupełnić informacje. Dzięki temu proces rejestracji jest prosty i intuicyjny, a ty będziesz mógł swobodnie korzystać z naszego systemu.',
        content: '10bh-content',
        header: '10bh-header',
    },
    {
        key: 2,
        question: 'Jakie są wymagania i procedury rejestracji dla podwykonawców?',
        answer: 'Odpowiedź na pytanie nr 2',
        content: '20bh-content',
        header: '20bh-header',
    },
    {
        key: 3,
        question: 'Czy jesteście otwarci na współpracę z podwykonawcami w różnych regionach geograficznych?',
        answer: 'Odpowiedź na pytanie nr 3',
        content: '4bh-content',
        header: '4bh-header',
    },
    {
        key: 4,
        question: 'Czy dostarczacie wsparcie techniczne i szkolenia dla podwykonawców korzystających z waszego systemu? ',
        answer: 'Odpowiedź na pytanie nr 4',
        content: '4bh-content',
        header: '4bh-header',
    },
    {
        key: 5,
        question: 'Czy system wymaga uzupełniania wolnej przestrzeni magazynowej na bieżąco?',
        answer: 'Odpowiedź na pytanie nr 5',
        content: '4bh-content',
        header: '4bh-header',
    },
    {
        key: 6,
        question: '<b>Jakie są korzyści i konkurencyjne zalety współpracy z wami jako podwykonawcą?</b>',
        answer: '<b>Elastyczność:</b> Nasz system oferuje elastyczne zarządzanie przestrzenią magazynową, pozwalając dostosować usługi do indywidualnych potrzeb klientów. <br /><br /><b>Nowe możliwości biznesowe:</b> Nasza platforma może otworzyć przed tobą nowe możliwości biznesowe, pomagając dotrzeć do szerszego grona klientów i rozbudowania oferty magazynu o nowe nieobsługiwane dotąd branże. <br /><br /><b>Optymalizacja kosztów:</b> Dzięki naszemu systemowi, możesz zoptymalizować koszty magazynowania przez wykorzystanie ,,końcówek” przestrzeni magazynowej, co może przekładać się na bardziej konkurencyjne ceny dla klientów. <br /><br /><b>Skuteczne zarządzanie przestrzenią magazynową:</b> Nasz system pozwala na skuteczne zarządzanie przestrzenią magazynową, eliminując błędy ludzkie i zwiększając dokładność. <br /><br /><b>Rozwój w miarę rozwoju klientów:</b> Możliwość korzystania z wielu magazynów pozwala na szybki rozwój twojego biznesu wraz z rozwojem obsługiwanych klientów.',
        content: '4bh-content',
        header: '4bh-header',
    },
    {
        key: 7,
        question: 'Czy system umożliwia łatwą i przejrzystą komunikację między podwykonawcami a klientami?',
        answer: 'Odpowiedź na pytanie nr 7',
        content: '4bh-content',
        header: '4bh-header',
    },
    {
        key: 8,
        question: 'Czy istnieją jakieś specjalne wymagania dotyczące bezpieczeństwa i jakości obsługi, które muszę spełnić jako podwykonawca? ',
        answer: 'Odpowiedź na pytanie nr 8',
        content: '4bh-content',
        header: '4bh-header',
    },
    {
        key: 9,
        question: 'Czy dostępne są narzędzia do monitorowania i raportowania działań podwykonawców w systemie?',
        answer: 'Odpowiedź na pytanie nr 9',
        content: '4bh-content',
        header: '4bh-header',
    },
    {
        key: 10,
        question: 'Czy współpraca z wami jako podwykonawcą może przyczynić się do rozwoju mojego biznesu w dziedzinie usług magazynowych?',
        answer: 'Odpowiedź na pytanie nr 10',
        content: '4bh-content',
        header: '4bh-header',
    },
    {
        key: 11,
        question: '<b>Czy istnieje możliwość zintegrowania mojego istniejącego systemu zarządzania magazynem z waszym oprogramowaniem?</b>',
        answer: 'Tak, istnieje możliwość zintegrowania twojego istniejącego systemu zarządzania magazynem z naszym oprogramowaniem. Nasza platforma jest przyjazna dla integracji i zapewnia wsparcie techniczne w celu skutecznego połączenia obu systemów. Proces integracji zostanie dokładnie omówiony i dostosowany do twoich potrzeb, aby zapewnić płynną i efektywną wymianę danych między systemami. ',
        content: '4bh-content',
        header: '4bh-header',
    },
    {
        key: 12,
        question: 'Czy system umożliwia dostęp do analizy danych dotyczących dostępności przestrzeni magazynowej i popytu na konkretne lokalizacje?',
        answer: 'Odpowiedź na pytanie nr 12',
        content: '4bh-content',
        header: '4bh-header',
    },
    {
        key: 13,
        question: 'Czy jako podwykonawca mam dostęp do narzędzi do raportowania i analizy efektywności mojej działalności w systemie?',
        answer: 'Odpowiedź na pytanie nr 13',
        content: '4bh-content',
        header: '4bh-header',
    },
    {
        key: 14,
        question: ' Jakie są zasady i harmonogramy rozliczeń związane z korzystaniem z waszego systemu jako podwykonawca?',
        answer: 'Odpowiedź na pytanie nr 14',
        content: '4bh-content',
        header: '4bh-header',
    },
    {
        key: 15,
        question: 'Czy system zapewnia wsparcie w zarządzaniu zapasami i optymalizacji dostaw w ramach mojej działalności jako podwykonawcy? ',
        answer: 'Odpowiedź na pytanie nr 15',
        content: '4bh-content',
        header: '4bh-header',
    },
    {
        key: 16,
        question: 'Czy istnieje możliwość skorzystania z waszego systemu w celu zwiększenia widoczności mojego biznesu jako podwykonawcy i pozyskania nowych klientów?',
        answer: 'Odpowiedź na pytanie nr 16',
        content: '4bh-content',
        header: '4bh-header',
    },
    {
        key: 17,
        question: 'Czy oferujecie szkolenia i wsparcie techniczne dla nowych podwykonawców, aby pomóc im w dostosowaniu się do systemu i procedur? ',
        answer: 'Odpowiedź na pytanie nr 17',
        content: '4bh-content',
        header: '4bh-header',
    },
    {
        key: 18,
        question: 'Czy system umożliwia łatwe zarządzanie harmonogramem dostaw i przyjmowania zleceń od klientów jako podwykonawca?',
        answer: 'Odpowiedź na pytanie nr 18',
        content: '4bh-content',
        header: '4bh-header',
    }
]

export const Faq = () => {
    const navigate = useNavigate();

    return (
        <PageContainer>
            <Zero>
                <HedSubtitle>Faq</HedSubtitle>
            </Zero>
            <Container>
                <First>
                    <MainTitle>Często zadawane <br /> pytania</MainTitle>
                    <Description>Nie widzisz odpowiedzi na nurtujące Cię pytanie?
                        <StyledLink onClick={() => navigate(url.contact)}><span> Skontaktuj się z nami</span></StyledLink>
                    </Description>
                    <KContactBox>
                        <AdSmallTextBar />
                        <AdSmallText>
                            Tel. +48 123 456 789 <br /> <br />Mail. pomoc@emagazyn.pl
                        </AdSmallText>
                    </KContactBox>
                </First>
                <Second>
                    <QuestionCategory listTitle={subtitle1} questionList={faqTable1} />
                    <QuestionCategory listTitle={subtitle2} questionList={faqTable2} />
                    {/* <QuestionCategory listTitle={subtitle3} questionList={faqTable3} /> */}
                </Second>
            </Container>
            {/* //Todo NAVIGATION */}
            <ImagesSection />
        </PageContainer >
    );
};